import { render, staticRenderFns } from "./lang-toggle.vue?vue&type=template&id=416ccc60&scoped=true&"
import script from "./lang-toggle.vue?vue&type=script&lang=ts&"
export * from "./lang-toggle.vue?vue&type=script&lang=ts&"
import style0 from "./lang-toggle.vue?vue&type=style&index=0&id=416ccc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ccc60",
  null
  
)

export default component.exports